import { CalendarViewTemplate } from "app/features/calendar/templates/CalendarViewTemplate";

export default function CalendarScreen() {
  return <CalendarViewTemplate />;
}
